<template>
  <form class="w-100" @submit.prevent="submit">
    <div class="row">
      <div class="col-12 text-left">
        <button v-if="id !== 'new'" @click="del" type="button" class="btn btn-danger">
          حذف ورژن
          <i class="fas fa-trash"/>
        </button>
        <button type="submit" class="btn btn-success mr-2">
          <span v-if="id !== 'new'">
            بروررسانی ورژن
          <i class="far fa-save"/>
          </span>
          <span v-else>
            افزودن ورژن جدید
                <i class="fas fa-plus"/>
          </span>
        </button>
        <hr>
      </div>
      <div v-if="id !== 'new'" class="col-12 col-sm-6 col-lg-3">
        <StatsCard>
          <div class="icon-big text-center icon-info" slot="header">
            <i class="fas fa-clock"/>
          </div>
          <div class="text-right" slot="content">
            <p><b>زمان ایجاد</b></p>
            {{$dateTimeFormat(item.created_at)}}
          </div>
        </StatsCard>
      </div>
      <div v-if="id !== 'new'" class="col-12 col-sm-6 col-lg-3">
        <StatsCard>
          <div class="icon-big text-center icon-warning" slot="header">
            <i v-if="item.os === 'ANDROID'" class="fab fa-android"/>
            <i v-else-if="item.os === 'IOS'" class="fab fa-apple"/>
          </div>
          <div class="text-right" slot="content">

            <p><b>سیستم عامل</b></p>
            {{item.os}}
          </div>
        </StatsCard>
      </div>


      <div v-if="id === 'new'  || ( Object.keys(item).length > 0 )" class="col-12">

        <div class="row">
          <div class="col-12">
            <card class="card" title="اطلاع پایه">
              <div>
                <div class="form-row">
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="os">سیستم عامل</label>
                      <fvSelect id="os" class="form-control select text-right fv-size-md"
                                v-model="item.os"
                                :options="OS"
                      />
                    </div>
                  </div>
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="order">ترتیب</label>
                      <input id="order" type="number" class="form-control" placeholder="ترتیب"
                             v-model.number="item.order">
                    </div>
                  </div>
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="min_os_version">حداقل ورژن سیستم عامل</label>
                      <input id="min_os_version" type="number" class="form-control" placeholder="حداقل ورژن سیستم عامل"
                             v-model.number="item.min_os_version">
                    </div>
                  </div>
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="version_no">شماره ورژن(فقط عدد)</label>
                      <input id="version_no" type="number" class="form-control" placeholder="شماره ورژن(فقط عدد)"
                             v-model.number="item.version_no">
                    </div>
                  </div>
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="version_no_str">شماره ورژن(STRING)</label>
                      <input id="version_no_str" type="text" class="form-control" placeholder="شماره ورژن(STRING)"
                             v-model="item.version_no_str">
                    </div>
                  </div>
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="web_url">Web Url</label>
                      <input id="web_url" type="text" class="form-control" placeholder="Web Url"
                             v-model="item.web_url">
                    </div>
                  </div>
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="android_url">android_url</label>
                      <input id="android_url" type="text" class="form-control" placeholder="android_url"
                             v-model="item.android_url">
                    </div>
                  </div>
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="os_version">os_version</label>
                      <input id="os_version" type="number" class="form-control" placeholder="os_version"
                             v-model.number="item.os_version">
                    </div>
                  </div>
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="enable">فعال</label>
                      <fv-switch id="enable" class="form-control d-block" placeholder="فعال"
                                 v-model="item.enabled"/>
                    </div>
                  </div>
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="force_update">Force Update</label>
                      <fv-switch id="force_update" class="form-control d-block" placeholder="Force Update"
                                 v-model="item.force_update"/>
                    </div>
                  </div>
                </div>
                <div class="clearfix"/>
              </div>
            </card>
            <card class="card text-right" title="ویژگی ها">
              <div>
                <div class="form-row">
                  <div class="col-12 col-md-6 mb-3" v-for="(val , i) in item.features">
                    <div class="form-group text-right d-flex flex-wrap">
                      <label class="w-100" :for="'feature' + i">ویژگی {{(i + 1)}}</label>
                      <input :id="'feature' + i " type="text" class="form-control" :placeholder="'ویژگی' + (i + 1) "
                             v-model="item.features[i]">
                      <button @click.prevent="item.features.splice(i, 1)" class="btn btn-outline-danger mt-2 mr-auto">پاک
                        کردن
                        <i class="fa fa-trash"/>
                      </button>
                    </div>
                  </div>
                  <div class="col-12 mt-3 text-left">
                    <button @click.prevent="item.features.push('')" class="btn btn-outline-primary">
                      اضافه کردن
                      <i class="fas fa-plus"/>
                    </button>
                  </div>
                </div>
              </div>
            </card>
          </div>
        </div>


      </div>


    </div>
  </form>
</template>
<script>
  import Modela from 'modela'
  import versionModel from "../../../models/versions"
  import {mapActions} from "vuex"
  import {StatsCard} from "@/components/index";

  export default {
    name: 'edit_content',
    components: {
      StatsCard,
    },
    data() {
      const {params} = this.$route
      const {id} = params
      return {
        ...mapActions('main', [
          'crud'
        ]),
        id,
        item: {},
        disableEditor: id !== 'new',
        OS: this.$store.state.main.OS
      }
    },
    methods: {
      async getData() {
        try {
          this.$store.commit('main/SET', {key: 'loading', value: true})
          const versions = await this.crud({
            action: 'get',
            section: 'versions',
            id: this.id,
            showError: true
          })
          if (versions.data) {

            const result = versions.data
            let item = new Modela(versionModel)
            item = item.$clean()
            item = item.$set(result)
            this.item = item.$clean().$export()
          }
        } catch (e) {
          // console.log(e)
        } finally {
          this.$store.commit('main/SET', {key: 'loading', value: false})
        }
      },
      async post() {
        try {
          this.$store.commit('main/SET', {key: 'loading', value: true})
          const newVersion = await this.crud({
            action: 'post',
            section: 'versions',
            data: this.item,
            showError: true
          })
          this.$successAlert()
          // this.$router.go(-1)
          await this.$router.push({name: 'versions'})
        } catch (e) {
          // console.log(e)
        } finally {
          this.$store.commit('main/SET', {key: 'loading', value: false})
        }

      },
      async put() {
        try {
          this.$store.commit('main/SET', {key: 'loading', value: true})
          const updateVersion = await this.crud({
            action: 'put',
            section: 'versions',
            id: this.id,
            data: this.item,
            showError: true
          })
          this.$successAlert()
          // this.$router.go(-1)
          await this.$router.push({name: 'versions'})
        } catch (e) {
          // console.log(e)
        } finally {
          this.$store.commit('main/SET', {key: 'loading', value: false})
        }

      },
      async del() {
        if (!await this.$confirmAlert())
          return false
        try {
          this.$store.commit('main/SET', {key: 'loading', value: true})
          const deleted = await this.crud({
            action: 'delete',
            section: 'versions',
            id: this.id,
            showError: true
          })
          await this.$successAlert()
          await this.$router.push({name: 'versions'})
          // this.$router.go(-1)
        } catch (e) {
          // console.log(e)
        } finally {
          this.$store.commit('main/SET', {key: 'loading', value: false})
        }
      },
      async submit() {
        if (this.id !== 'new')
          this.put()
        else
          this.post()
      }
    },
    async created() {
      if (this.id !== 'new')
        await this.getData()
      else {
        let item = new Modela(versionModel)
        this.item = item.$clean().$export()
      }
    }
  };
</script>
